import { UserOutlined } from "@ant-design/icons"
import { Tag, Tooltip, Typography } from "antd"
import type React from "react"
import { Link } from "react-router-dom"

const { Text } = Typography

export interface UserCellLinkProps {
  user?: {
    id?: number
    name?: string | null
    username?: string | null
    email?: string | null
    is_test?: number
  } | null
  userId?: number
  name?: string | null
  email?: string | null
  subtitle?: React.ReactNode
  fallback?: React.ReactNode
  className?: string
}

export const UserCellLink: React.FC<UserCellLinkProps> = ({
  user,
  userId,
  name,
  email,
  subtitle,
  fallback,
  className = "",
}) => {
  const targetEmail = email ?? user?.email ?? null
  const targetName = name ?? user?.name ?? user?.username ?? null
  const targetId = userId ?? user?.id

  if (!user && !targetEmail && !targetName && !targetId) {
    return fallback ? <>{fallback}</> : <Text type="secondary">—</Text>
  }

  // Determine query search term: prefer email, fallback to #id, then username/name
  const searchTerm = targetEmail || (targetId ? `#${targetId}` : targetName)

  const content = (
    <div className={`flex flex-col gap-0.5 leading-tight ${className}`}>
      <div className="flex flex-wrap items-center gap-1.5 font-medium text-gray-800 transition-colors group-hover:text-blue-600">
        <UserOutlined className="shrink-0 text-blue-500!" />
        <span className="max-w-[150px] truncate">{targetName || targetEmail || "Người dùng"}</span>
        {targetId && (
          <Tag color="blue" className="m-0 shrink-0 px-1 py-0 text-[10px] leading-4">
            #{targetId}
          </Tag>
        )}
        {user?.is_test === 1 && (
          <Tag color="warning" className="m-0 shrink-0 px-1 py-0 font-semibold text-[10px]">
            Test
          </Tag>
        )}
      </div>
      {(subtitle !== undefined ? subtitle : targetEmail) && (
        <span className="max-w-[180px] truncate text-gray-500 text-xs transition-colors group-hover:text-blue-500 group-hover:underline">
          {subtitle !== undefined ? subtitle : targetEmail}
        </span>
      )}
    </div>
  )

  if (searchTerm) {
    return (
      <Tooltip title={`Xem trong DS User: ${searchTerm}`}>
        <Link
          to={`/user-account?search=${encodeURIComponent(searchTerm)}`}
          onClick={(e) => e.stopPropagation()}
          className="group inline-block cursor-pointer"
        >
          {content}
        </Link>
      </Tooltip>
    )
  }

  return content
}

export default UserCellLink
